import { I18nLocale } from '#/i18n/types/I18nLocale';

type PageTypeAndLocale =
  | {
      isHelpPage: true;
      locale: I18nLocale;
    }
  | { isHelpPage: false; locale: null };

const denyListedPaths = new Set(['/en/help/', '/es/ayuda/']);

export function getPageTypeAndLocale(pathname: string): PageTypeAndLocale {
  const pathnameWithSlash = `${pathname}/`;
  if (denyListedPaths.has(pathname) || denyListedPaths.has(pathnameWithSlash)) {
    return {
      isHelpPage: false,
      locale: null,
    };
  }

  if (pathname.startsWith('/en/help')) {
    return {
      isHelpPage: true,
      locale: I18nLocale.EN,
    };
  }

  if (pathname.startsWith('/es/ayuda')) {
    return {
      isHelpPage: true,
      locale: I18nLocale.ES,
    };
  }

  return { isHelpPage: false, locale: null };
}
